export function buildCompanyProfileExpansionPayload(
  organizationNumber: string,
  contextId: string,
  expandVehiclesForCompany = false,
) {
  return {
    orgNumbers: [organizationNumber],
    contextId,
    createContext: false,
    ...(expandVehiclesForCompany ? { expandVehiclesForCompany: true } : {}),
  };
}

export function formatCompanyProfileExpansionError(
  status: number,
  statusText: string,
  responseBody: string,
  requestId?: string | null,
): string {
  const parts = [
    `${status}${statusText ? ` ${statusText}` : ''}`,
    responseBody.trim(),
    requestId ? `Request ID: ${requestId}` : '',
  ].filter(Boolean);

  return parts.join(': ');
}
